import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import secureLocalStorage from "react-secure-storage";
import verifytoken from "../../env/verifytoken";
import { config } from "../../utils/config";
import Sidebar from "../../components/Sidebar";
import VariationCountPopup from "../../components/VariationCountPopup";
import VariationCountLabel from "../../components/VariationCountLabel";
import {
  doRequest,
  getSubscriptionStatus,
  textItemRender,
} from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
//import { setDimensions } from "../../redux/slices/SizeSlice";
//import { removeFromIndexedDB } from "../../utils/indexedDB";
import {
  setPlanDetails,
  /*  updateName,
    updateNum, */
} from "../../redux/slices/PlanDetailSlice";
import KEYS from "../../env/env";
import { getDesignsList } from "../../redux/slices/DesignSlice";
import moment from "moment";
import Modal from "../../components/modal";
import { toast } from "react-toastify";
import RcPagination from "rc-pagination";
import localeInfo from "rc-pagination/lib/locale/en_US";
import { set } from "react-hook-form";

// Static designs array for reference - commented out for dynamic implementation
// const designs = Array.from({ length: 14 }).map((_, i) => ({
//   id: i + 1,
//   name: `Name limit example.TDX`,
//   size: `23MB`,
//   edited: `15min ago`,
//   img: i % 2 === 0 ? "/assets/images/dimg01.png" : "/assets/images/dimg02.png",
// }));

const getLocalStorageJson = (key, defaultValue = null) => {
  try {
    const value = localStorage.getItem(key);
    if (!value || value === "undefined") return defaultValue;
    return JSON.parse(value);
  } catch (e) {
    console.error(`Error parsing localStorage key ${key}`, e);
    return defaultValue;
  }
};


function MyDesigns() {
  const dispatch = useDispatch();
  const userPlanDetails = useSelector((state) => state.userPlan);
    const userData = useSelector((state) => state.user.userData);
  
  //   const { designs } = useSelector((state) => state.design);
  const [showVariationCountPopup, setShowVariationCountPopup] = useState(false);
  // const [variationCountLeft, setVariationCountLeft] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [newDesignName, setNewDesignName] = useState("");
  const [selectedDesignId, setSelectedDesignId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const limit = 14;
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [designs, setDesigns] = useState([]);
  const [localUI, setLocalUI] = useState({
    isSubmitting: false,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // const aSizes = ["a4", "a3", "a2", "a1"];

  const getDesignLists = async (p) => {
    let data = {};
    try {
      data = {
        page: p ? p : page,
        limit: limit,
      };
      let url = `design/list?page=${data.page}&limit=${data.limit}`;
      const response = await doRequest(data, "GET", url);
      setDesigns(response?.response?.data || []);
      setTotalRecords(response?.response?.pagination?.total);
    } catch (error) {}
  };

  useEffect(() => {
    // dispatch(getDesignsList());
    getDesignLists();
  }, []);

  // var token = secureLocalStorage.getItem("Login");
  var token = localStorage.getItem("Login");

  useEffect(() => {
    if (queryParams.get("token") && queryParams.get("email")) {
      let usestatus = queryParams.get("isNewUser");
      // secureLocalStorage.setItem("Login", queryParams.get("token"));
      localStorage.setItem("Login", queryParams.get("token"));
      localStorage.setItem("token", queryParams.get("token"));
      callUserDataApi(queryParams.get("token"), queryParams.get("email"));
      if (usestatus == "true") {
        console.log("inside navigate", usestatus);
        navigate("/plans");
      } else {
        console.log("inside else navigate", usestatus);
      }
    } else if (!token) {
      navigate("/");
    } else if (token == null) {
      navigate("/");
    } else {
      var tokenExpired = verifytoken();
      if (tokenExpired) {
        navigate("/");
      } else {
        let planDetails = getLocalStorageJson(config.USER_PLAN_DETAILS, null);


        let variantDetails = getLocalStorageJson(config.VARIANT_COUNT, null);


        // setVariationCountLeft(variantDetails?.remaning);
        if (+planDetails?.plan_id == 5 || +planDetails?.plan_id === 1) {
          if (variantDetails?.remaning < 4) setShowVariationCountPopup(true);
        } else {
          let status = getSubscriptionStatus(planDetails);
          if (status === "Subscription expired") {
            setShowVariationCountPopup(true);
          }
        }
      }
    }
  }, [token]);

  const callUserDataApi = async (token, email) => {
    let data = {
      email: email,
    };
    fetch(KEYS.apiPath + "user/data", {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then(async (val) => {
        if (+val.resultFlag === 1) {
          let userDetails = val?.response?.user;
          let userPlanDetails = val?.response?.userPlan;
          let variants = val?.response?.variants;

          localStorage.setItem(
            config.USER_LOGIN_DETAILS,
            JSON.stringify(userDetails)
          );
          localStorage.setItem(
            config.USER_PLAN_DETAILS,
            JSON.stringify(userPlanDetails)
          );
          if (variants) {
            localStorage.setItem(
              config.VARIANT_COUNT,
              JSON.stringify(variants)
            );
            dispatch(setPlanDetails({ userPlanDetails: userPlanDetails }));
          }
        } else {
        }
      })
      .catch((err) => {});
  };

  localStorage.removeItem("bgImageDetails");
  localStorage.removeItem("playernamedetails");
  localStorage.removeItem("tshirtDetails");
  localStorage.removeItem("playernumberdetails");
  localStorage.removeItem("tshirtchangedetails");
  localStorage.removeItem("bgname");

  const [selected, setSelected] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSelect = (id) => {
    // setSelected((prev) =>
    //     prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    // );

    if (selected.includes(id)) {
      setSelected(selected.filter((x) => x !== id));
    } else {
      setSelected([...selected, id]);
    }
  };

  const handleDelete = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  // Filter designs based on search query
  const filteredDesigns =
    designs?.filter((design) =>
      design.design_name.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];
  // Add click handler to close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const menus = document.querySelectorAll(".more-menu");
      menus.forEach((menu) => {
        if (
          !menu.contains(event.target) &&
          !event.target.closest(".more-button")
        ) {
          menu.style.display = "none";
        }
      });
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  // Rename Design
  const handleDesignRename = async (e) => {
    e.preventDefault();
    if (newDesignName.trim()) {
      try {
        setLocalUI({
          ...localUI,
          isSubmitting: true,
        });
        const response = await fetch(
          KEYS.apiPath + "design/update/" + selectedDesignId,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              design_name: newDesignName,
            }),
          }
        );
        const data = await response.json();
        if (data.resultFlag === 1) {
          setShowModal(false);
          setNewDesignName("");
          setSelectedDesignId(null);
          dispatch(getDesignsList());
          setLocalUI({
            ...localUI,
            isSubmitting: false,
          });
        }
      } catch (error) {
        setLocalUI({
          ...localUI,
          isSubmitting: false,
        });
        console.error("Error:", error);
      }
    }
  };

  const handleDeleteSelectedDesigns = async () => {
    try {
      setLocalUI({
        ...localUI,
        isSubmitting: true,
      });

      for (let i = 0; i < selected.length; i++) {
        await handleDesignDelete(selected[i], true);
      }
      setSelected([]);
      setShowDeleteModal(false);
    } catch (e) {
      toast.error(`Error deleting designs: ${e.message}`);
    } finally {
      setLocalUI({
        ...localUI,
        isSubmitting: false,
      });
    }
  };

  // Delete Design
  const handleDesignDelete = async (designId, isMultiple = false) => {
    try {
      if (!isMultiple) {
        setLocalUI({
          ...localUI,
          isSubmitting: true,
        });
      }
      const response = await fetch(KEYS.apiPath + "design/delete/" + designId, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (data.resultFlag === 1) {
        setSelectedDesignId(null);
        dispatch(getDesignsList());

        if (!isMultiple) {
          setShowDeleteModal(false);
          setLocalUI({
            ...localUI,
            isSubmitting: false,
          });
        }
      }
    } catch (error) {
      if (!isMultiple) {
        setLocalUI({
          ...localUI,
          isSubmitting: false,
        });
      }

      console.error("Error:", error);
    }
  };
  return (
    <>
      {showVariationCountPopup && (
        <VariationCountPopup close={() => setShowVariationCountPopup(false)} />
      )}
      {showModal && (
        <Modal
          close={() => {
            setShowModal(false);
          }}
        >
          <form
            style={{
              width: "20vw",
              gap: "1rem",
              display: "flex",
              flexDirection: "column",
            }}
            onSubmit={handleDesignRename}
          >
            <h5>Rename Design</h5>
            <input
              type="text"
              className="form-control"
              value={newDesignName}
              onChange={(e) => setNewDesignName(e.target.value)}
              placeholder="Enter design name"
              onKeyDown={(e) => {
                if (e.key === "Escape") {
                  setShowModal(false);
                  setNewDesignName("");
                  setSelectedDesignId(null);
                }
                // if (e.key === "Enter" && newDesignName.trim()) {
                //     setShowModal(false);
                //     setNewDesignName("");
                //     setSelectedDesignId(null);
                // } else if (e.key === "Escape") {
                //     setShowModal(false);
                //     setNewDesignName("");
                //     setSelectedDesignId(null);
                // }
              }}
              autoFocus
            />
            <div className="modal-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setShowModal(false);
                  setNewDesignName("");
                  setSelectedDesignId(null);
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                // onClick={handleDesignRename}
                disabled={localUI.isSubmitting}
              >
                {localUI.isSubmitting ? "Renaming..." : "Rename"}
              </button>
            </div>
          </form>
        </Modal>
      )}
      {showDeleteModal && (
        <Modal
          close={() => {
            setShowDeleteModal(false);
          }}
        >
          <div
            style={{
              width: "20vw",
              gap: "1rem",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <h5>Delete Design</h5>
            <p>
              Are you sure you want to delete{" "}
              <strong>
                {selected.length > 1
                  ? `${selected.length} designs`
                  : "this design"}
              </strong>{" "}
              ?
            </p>
            <div className="modal-actions">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowDeleteModal(false);
                  setSelectedDesignId(null);
                  setNewDesignName("");
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={() => {
                  if (selected.length > 0) {
                    handleDeleteSelectedDesigns();
                  } else {
                    handleDesignDelete(selectedDesignId);
                  }
                }}
                disabled={localUI.isSubmitting}
              >
                {localUI.isSubmitting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </Modal>
      )}
      <div id="main-container" className="container-fluid main">
        <div class="left-main-menu">
          <Sidebar />
        </div>
        <section className="home yourdesign" style={{ paddingLeft: 0 }}>
          <div className="upgradeButtonFixed">
            <VariationCountLabel userPlanDetails={userPlanDetails} />
          </div>

          {/* <div className="storage-info">
                        <span>20MB</span>/<span>500MB</span>Storage
                    </div> */}

          <h1>Your Teedex Designs</h1>
          <div className="your-design-search">
            <input
              type="text"
              placeholder="Search in your designs"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <img src={"/assets/images/search_black_icn.svg"} alt="" />
          </div>

          <div className="your-design-section">
            <div className="your-design-section-head">
              <h4>
                <img src="/assets/images/folder_open_icon.svg" alt="" /> Your
                Designs{" "}
                {searchQuery
                  ? `${filteredDesigns.length} of ${designs?.length || 0}`
                  : designs?.length || 0}
              </h4>

              {selected.length > 0 && (
                <div
                  className="delete-design"
                  onClick={() => {
                    setShowDeleteModal(true);
                  }}
                >
                  <img src="/assets/images/delete_red_icn.svg" alt="" /> Delete{" "}
                  {selected.length} File
                  {selected.length > 1 ? "s" : ""}
                </div>
              )}
            </div>

            <div className="your-design-section-list">
              {filteredDesigns.map((design) => {
                const updatedAt = moment(design.updated_at);
                const now = moment();
                const diffMinutes = now.diff(updatedAt, "minutes");
                const diffHours = now.diff(updatedAt, "hours");
                const diffDays = now.diff(updatedAt, "days");

                let timeAgo = "";
                if (diffMinutes < 60) {
                  timeAgo = `${diffMinutes}min ago`;
                } else if (diffHours < 24) {
                  timeAgo = `${diffHours}h ago`;
                } else {
                  timeAgo = `${diffDays}d ago`;
                }

                return (
                  <div
                    key={design.id}
                    className={`your-design-section-item ${
                      selected.includes(design.id) ? "selected" : ""
                    }`}
                    onClick={(e) => {
                      // Check if the click target is the checkbox or its label
                      const target = e.target;
                      const isCheckboxClick =
                        target.type === "checkbox" ||
                        target.closest(".your-design-section-item-checkbox");

                      if (isCheckboxClick) {
                        e.stopPropagation();
                        return;
                      }

                      e.stopPropagation();
                      window.open(`/Design/${design.id}`, "_blank");
                    }}
                  >
                    <label
                      className="your-design-section-item-checkbox"
                      onClick={(e) => {
                        console.log("on label clicked");
                        e.preventDefault();
                        e.stopPropagation();
                        handleSelect(design.id);
                      }}
                      onMouseDown={(e) => {
                        console.log("on label mousedown");
                        e.preventDefault();
                        e.stopPropagation();
                        // handleSelect(design.id);
                      }}
                    >
                      <input
                        style={{
                          zIndex: 1000,
                        }}
                        type="checkbox"
                        checked={selected.includes(design.id)}
                        onChange={(e) => {
                          console.log("on change");
                          e.preventDefault();
                          e.stopPropagation();
                          handleSelect(design.id);
                        }}
                        onClick={(e) => {
                          console.log("on clicked");
                          e.preventDefault();
                          e.stopPropagation();
                          handleSelect(design.id);
                        }}
                        onMouseDown={(e) => {
                          console.log("on mouse down");
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      />
                      <img src="/assets/images/checked_icn.svg" alt="" />
                    </label>
                    <div className="your-design-section-item-img">
                     {design.design_thumbnail_url && <img
                        src={
                          design.design_thumbnail_url ||
                          "/assets/images/dimg01.png"
                        }
                        alt={design.design_name}
                        onError={(e) => {
                          e.target.src = "/assets/images/dimg01.png";
                        }}
                      />}
                    </div>
                    <h5>{design.design_name}.tdx</h5>
                    <h6>Edited {timeAgo}</h6>
                    {userData?.type === "admin" && (
                        <h6>{design.user_name}</h6>
                      )}
                    <div
                      className="your-design-section-item-more"
                      style={{ padding: "0" }}
                    >
                      <button
                        className="more-button"
                        style={{
                          background: "none",
                          border: "none",
                          padding: "1rem",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={(e) => {
                          // Prevent event bubbling to parent
                          e.preventDefault();
                          e.stopPropagation();

                          // Toggle menu visibility
                          const menu = e.currentTarget.nextElementSibling;
                          menu.style.display =
                            menu.style.display === "none" ? "block" : "none";
                        }}
                      >
                        <img
                          src={"/assets/images/more_icn.svg"}
                          alt="more icon"
                        />
                      </button>
                      <div
                        className="more-menu"
                        style={{
                          display: "none",
                          position: "absolute",
                          right: "0",
                          top: "100%",
                          background: "#fff",
                          boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                          borderRadius: "4px",
                          zIndex: 1000,
                        }}
                      >
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            const designId = design.id;

                            setShowModal(true);
                            setSelectedDesignId(designId);
                            setNewDesignName(design.design_name);
                            e.currentTarget.parentElement.style.display =
                              "none";
                          }}
                          style={{
                            display: "block",
                            width: "100%",
                            padding: "8px 16px",
                            border: "none",
                            background: "none",
                            textAlign: "left",
                            cursor: "pointer",
                            transition: "background-color 0.2s",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor = "#f5f5f5")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "transparent")
                          }
                        >
                          Rename
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            const designId = design.id;

                            setShowDeleteModal(true);
                            setSelectedDesignId(designId);
                            setNewDesignName(design.design_name);
                            e.currentTarget.parentElement.style.display =
                              "none";
                          }}
                          style={{
                            display: "block",
                            width: "100%",
                            padding: "8px 16px",
                            border: "none",
                            background: "none",
                            textAlign: "left",
                            cursor: "pointer",
                            color: "#ff4444",
                            transition: "background-color 0.2s",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor = "#fff1f1")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "transparent")
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="mt-2 p-4 d-flex justify-content-center">
              <RcPagination
                total={totalRecords}
                locale={localeInfo}
                pageSize={limit}
                current={page}
                itemRender={textItemRender}
                onChange={(page) => {
                  setPage(page);
                  getDesignLists(page);
                }}
              />
            </div>

            {showPopup && (
              <>
                <div className="designPopup">
                  <div className="designPopup-content">
                    <img src="/assets/images/teedex-logo.png" alt="" />
                    <h4>Sure want to delete it?</h4>
                    <button onClick={closePopup}>No</button>
                    <button
                      onClick={() => {
                        alert("Files deleted!");
                        setSelected([]);
                        setShowPopup(false);
                      }}
                    >
                      Yes
                    </button>
                  </div>
                </div>
                <div className="designPopupBg" onClick={closePopup}></div>
              </>
            )}
          </div>
        </section>
      </div>
    </>
  );
}

export default MyDesigns;
